import { formatPhone } from "../MessagesList/mentions";

// Marcar participantes ao escrever num grupo. No campo aparece "@Nome"; no envio cada
// "@Nome" escolhido vira "@<id do participante>" e os ids completos vão no campo `mentions`.

const fold = (value) =>
  String(value == null ? "" : value)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

// Há um "@" em aberto logo antes do cursor? Devolve { start, query } (start = posição do "@").
export const findMentionQuery = (text, caret) => {
  const before = String(text == null ? "" : text).slice(0, caret);
  const match = /(^|\s)@([^\s@]{0,30})$/.exec(before);
  if (!match) return null;
  return { start: before.length - match[2].length - 1, query: match[2] };
};

// Como o participante aparece no texto digitado: pelo nome; sem nome, pelo número.
export const mentionLabelOf = (participant) =>
  `@${participant.name || participant.number || participant.user}`;

export const participantTitle = (participant) => participant.name || formatPhone(participant.number) || "";

// Filtra pelo que vem depois do "@": começo do nome primeiro, depois qualquer parte do nome
// ou do número.
export const filterParticipants = (participants, query, limit = 50) => {
  const q = fold(query);
  const digits = String(query || "").replace(/\D/g, "");
  const ranked = [];
  (participants || []).forEach((p) => {
    const name = fold(p.name);
    let rank = -1;
    if (!q) rank = p.name ? 1 : 2;
    else if (name && name.startsWith(q)) rank = 0;
    else if (name && name.split(/\s+/).some((word) => word.startsWith(q))) rank = 1;
    else if (name && name.includes(q)) rank = 2;
    else if (digits && digits.length >= 2 && (p.number.includes(digits) || p.user.includes(digits))) rank = 3;
    if (rank >= 0) ranked.push({ p, rank });
  });
  return ranked
    .sort((a, b) => a.rank - b.rank || fold(a.p.name || "~").localeCompare(fold(b.p.name || "~")))
    .slice(0, limit)
    .map((r) => r.p);
};

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// Troca no texto os "@Nome" que continuam inteiros pelos ids. Rótulo que foi editado (apagaram
// parte do nome) não casa mais e fica como texto comum.
export const applyMentions = (text, picked) => {
  let body = String(text == null ? "" : text);
  const mentions = [];
  const holders = [];
  [...(picked || [])]
    .sort((a, b) => b.label.length - a.label.length)
    .forEach((item, i) => {
      const re = new RegExp(`(^|[^\\w@])${escapeRegExp(item.label)}(?![\\wÀ-ÿ])`, "g");
      let used = false;
      // marcador temporário: um rótulo não pode casar dentro do id que acabou de entrar
      const holder = `\u0000${i}\u0000`;
      body = body.replace(re, (match, lead) => {
        used = true;
        return `${lead}${holder}`;
      });
      if (!used) return;
      holders.push({ holder, token: `@${item.participant.user}` });
      if (!mentions.includes(item.participant.id)) mentions.push(item.participant.id);
    });
  holders.forEach(({ holder, token }) => {
    body = body.split(holder).join(token);
  });
  return { body, mentions };
};
